import { CustomerType } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import {
  WorkOrderComplement,
  WorkOrderComplementStatus,
  WorkOrderComplementTankLevel,
  WorkOrderComplementType,
} from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { DateTimeFormat } from '@/utils/moment';
import moment from 'moment';

const todayDate = moment().format(DateTimeFormat);

const complement: WorkOrderComplement = {
  id: 1,
  number: 1,
  workOrderGuid: '1',
  complementIdentifier: '000123/00',
  estimator: {
    id: 1,
    name: 'Dominic Toretto',
  },
  customerType: CustomerType.Private,
  type: WorkOrderComplementType.WorkOrder,
  insurer: undefined,
  status: WorkOrderComplementStatus.Authorized,
  accidentNumber: '',
  insurerDeductibleAmount: 0,
  entryDate: todayDate,
  authorizationDate: todayDate,
  closingDate: todayDate,
  estimatedLeaveDate: todayDate,
  reasonEstimatedLeaveDate: null,
  ssLocaliza: null,
  returnDate: todayDate,
  prisma: '',
  currentKilometers: 1,
  tankLevel: WorkOrderComplementTankLevel.Empty,
};

export default complement;
